import { Show } from 'solid-js';
import { cookieStore } from '~/stores/cookieStore';
import './CookieBanner.css';

export function CookieBanner() {
  return (
    <Show when={!cookieStore.isDecided()}>
      <div class="cookies" role="dialog" aria-label="Файлы cookie" aria-live="polite">
        <div class="cookies__inner">
          <Show
            when={!cookieStore.configureOpen()}
            fallback={
              <>
                <p class="cookies__text">
                  <strong>Настройки cookie.</strong> Необходимые cookie нужны для
                  работы корзины заявки, навигации и базовых функций сайта —
                  отключить их нельзя. Аналитические и рекламные cookie на сайте
                  пока не подключены. Если они появятся, мы запросим отдельное
                  согласие.
                </p>
                <div class="cookies__buttons">
                  <button
                    type="button"
                    class="btn btn--red"
                    onClick={cookieStore.acceptAll}
                  >
                    Принять все
                  </button>
                  <button
                    type="button"
                    class="btn btn--ghost"
                    onClick={cookieStore.acceptNecessary}
                  >
                    Только необходимые
                  </button>
                </div>
              </>
            }
          >
            <p class="cookies__text">
              Мы используем файлы cookie для корректной работы сайта и анализа
              посещаемости.{' '}
              <a class="cookies__link" href="/cookie-policy">
                Подробнее
              </a>
              .
            </p>
            <div class="cookies__buttons">
              <button
                type="button"
                class="btn btn--red"
                onClick={cookieStore.acceptAll}
              >
                Принять
              </button>
              <button
                type="button"
                class="btn btn--ghost"
                onClick={cookieStore.openConfigure}
              >
                Настроить
              </button>
              <button
                type="button"
                class="btn btn--ghost"
                onClick={cookieStore.acceptNecessary}
              >
                Только необходимые
              </button>
            </div>
          </Show>
        </div>
      </div>
    </Show>
  );
}
